import React, { useEffect, useState } from 'react'
import Sidebar from '../../Common/Sidebar/Sidebar';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axios from 'axios';
import { toast } from 'react-toastify';
import Modal from 'react-modal';
import AddKitabNamePopup from '../../Common/Popup/AddKitabNamePopup';
import { isMobile } from 'react-device-detect';

const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: isMobile ? "100%" : '55%'
    },
  };

export default function AddKitab() {
    const [kitabInfo, setKitabInfo] = useState({});
    const [kitabList, setKitabList] = useState([]);
    const [popup, setPopup] = useState(false);

    useEffect( ()  => {     
        async function fetchData() {   
         const kitabName = await axios.get(`https://ahlehaqserver.herokuapp.com/api/kitabName`)
         setKitabList(kitabName.data.response);
        }
        fetchData(); 
      },[popup])


    const saveKitabDetails = async (e) => {
        e.preventDefault();
        try {
          if(kitabInfo.description.length > 0){
            const kitabInserted = await axios.post(
              `https://ahlehaqserver.herokuapp.com/api/kitab`,
              kitabInfo
            );
    
            //if request success, will show success notification
            if (kitabInserted.data.code === 200) {
                setKitabInfo({});
              toast.success("Kitab details added successfully!");
              e.target.reset();
              CKEditor.setData('');
            }
          }else{
            toast('Please write description')
          }
         
        } catch (error) {
          console.log(error);
          // toast.error("Internal Server Error!");
        }
      };

    return (
        <div>
          <div className="row justify-content-center">
            <div className="col-md-7">
              <Modal isOpen={popup} style={customStyles}>
                  <AddKitabNamePopup
                  setPopup={setPopup}
                  />
              </Modal>
            </div>
          </div>

        <div>
            <div className="row">
                <div className="col-md-3">
                    <Sidebar/>
                </div>
                <div className="col-md-9">
                   <h1 className="ml-3">Add kitab details information</h1>
                   <form onSubmit={saveKitabDetails}>
                      <div className="row">
                         <div className="col-md-5 col-8">
                          <div className="form-group">
                              <label for="exampleInputEmail1" className="font-weight-bold">
                                Select Book Name<span className="text-danger">*</span>
                              </label>
                              
                              <select
                                className="form-control rounded"
                                id="exampleInputEmail1"
                                name="kitabName"
                                value={kitabInfo?.kitabName || ""}
                                required
                                onChange={(e) =>
                                    setKitabInfo((prev) => ({
                                    ...prev,
                                    [e.target.name]: e.target.value,
                                  }))
                                }
                              >
                                <option>
                                  {
                                    kitabList.length === 0 ? "Click add button and create new kitab name" :
                                    "Choose from the list or create new kitab name"
                                  }
                                </option>
                                {kitabList &&
                                  kitabList.map((data) => (
                                    <option value={data.kitabName}>
                                      {data.kitabName}
                                    </option>
                                  ))}
                              </select>  
                          </div>
                        </div>
                        <div className="col-md-1 col-2 addBtnPadding" >
                            <button
                            type="button"
                            className="btn btn-success addBtn"
                            onClick={() => setPopup(true)}
                            >
                                + Add
                            </button>
                        </div>

                         {
                           kitabInfo.kitabName && kitabList.find(data => data.kitabName === kitabInfo.kitabName).pdf === true ? 
                           <div className="col-md-6">
                           <div className="form-group">
                             <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                             Write pdf link <span className="text-danger">*</span>
                             </label>
                             <input
                               type="text"
                               className="form-control rounded"
                               placeholder="Write pdf link"
                               id="exampleInputPassword1"
                               name="pdfUrl"
                               value={kitabInfo?.pdfUrl || ""}
                               required
                               onChange={(e) =>
                                 setKitabInfo((prev) => ({
                                   ...prev,
                                   [e.target.name]: e.target.value,
                                 }))
                               }
                             />
                           </div>
                          </div>
                            : 
                            <>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                                  Chapter Name <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control rounded"
                                    placeholder="Write Chapter Title"
                                    id="exampleInputPassword1"
                                    name="chapter"
                                    value={kitabInfo?.chapter || ""}
                                    required
                                    onChange={(e) =>
                                      setKitabInfo((prev) => ({
                                        ...prev,
                                        [e.target.name]: e.target.value,
                                      }))
                                    }
                                  />
                                </div>
                              </div>

                                
                              <div className="col-md-12">
                              <div className="form-group">
                                    <label for="exampleInputEmail1" className="font-weight-bold">
                                      Write Description<span className="text-danger">*</span>
                                    </label>
                              
                                          <CKEditor
                                              editor={ ClassicEditor }
                                              data={kitabInfo?.description || ""}
                                              onChange={ ( event, editor ) => {
                                                  const data = editor.getData();
                                                  setKitabInfo((Prev) => ({ ...Prev, description: data }))
                                              } }
                                          />
                                  </div>   
                              </div>  
                            </>
                         }
                          
                         <div className="col-md-4">
                            <div className="mt-4 ">
                              <button
                                type="submit"
                                className="btn btn-success rounded-pill px-4 ml-auto"
                              >
                                Done
                              </button>
                            </div>  
                         </div> 

                      </div>

                      
                    </form>
                </div>
            </div> 
            </div>
        </div>
    )
}
